import React from "react";
import styled from "styled-components";

const Logo = () => {
  return (
    <LogoContainer>
      <a href="https://register.apegamobile.ca/">
        <LogoPic src="/images/ApegaLogo.png" alt="Apega Logo" />
      </a>
    </LogoContainer>
  );
};
const LogoContainer = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

const LogoPic = styled.img`
  width: 100px;
  @media (min-width: 769px) {
    position: fixed;
    top: 140px;
  }

  @media (max-width: 768px) {
    position: static;
    margin: 0 auto;
    display: block;
  }
`;

export default Logo;
